import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ReloadState = {
  blocked: boolean;
  count: number;
  firstReloadAt: number | null;
};

type ReloadActions = {
  reload: () => void;
};

type ReloadStore = ReloadState & ReloadActions;

const maxReloadCount = 2;
const timeWindowMs = 10_000;

export const useReloadStore = create<ReloadStore>()(
  persist(
    (set) => ({
      blocked: false,
      count: 0,
      firstReloadAt: null,

      reload: () =>
        set((state) => {
          const { firstReloadAt } = state;

          setTimeout(() => window.location.reload(), 0); // defer to allow state to persist

          const now = Date.now();

          if (!firstReloadAt || now - firstReloadAt > timeWindowMs) {
            return { firstReloadAt: now, count: 1, blocked: false };
          }

          const count = state.count + 1;
          return { count, blocked: count >= maxReloadCount };
        }),
    }),
    {
      name: 'reload',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
